import {React, useEffect, useState, useRef} from 'react'
import './payment.css'
import { Link, useLocation } from 'react-router-dom';

export function PaymentSuccessfull() {

    const homeLinkRef = useRef(null);
    const location = useLocation();
    const [paymentId, setPaymentId] = useState('')
    const [debugData, setDebugData] = useState(null);

    useEffect(() => {
        console.log("PaymentSuccessfull mounted. URL:", window.location.href);
        // Extract payment_id or status from URL query parameters
        const queryParams = new URLSearchParams(location.search);
        
        // Log all params for debugging/tracking identification
        const params = {};
        queryParams.forEach((value, key) => {
          params[key] = value;
        });
        
        const pid = queryParams.get("payment_id") || queryParams.get("id");
        if (pid) {
          setPaymentId(pid);
          console.log("Payment Successful! ID:", pid);
        }
        
        setDebugData(params);
        localStorage.setItem("TABBY_DEBUG_DATA", JSON.stringify(params));
        console.log("All success parameters stored in TABBY_DEBUG_DATA:", params);

        localStorage.removeItem("cart");
        localStorage.removeItem("promoCode");
        localStorage.removeItem("paymentType");
        localStorage.removeItem("requiredFields");
    }, [location.search]);

    useEffect(() => { 
        // scroll to the top of the page on mount
        window.scrollTo(0, 0);
      }, []);

  return (
    <div style={{height:'900px', display:'flex', justifyContent:'center', alignItems:'center'}}>
        <section className="login-main-wrapper">
        <div className="main-container">
          <div className="login-process">
            <div className="login-main-container">
              <div className="thankyou-wrapper">
                <h1><img class="payment-failed-img" src={process.env.PUBLIC_URL + "/images/payment_successful.png"} alt="thanks" /></h1>
                <p>Your payment is success , we will get in touch with you soon...</p>
                {paymentId && <p><strong>Payment ID:</strong> {paymentId}</p>}
                <p>please check your mail box for payment receipt </p>
                
                {debugData && (
                  <div style={{marginTop: '20px', textAlign: 'left', background: '#f4f4f4', padding: '15px', borderRadius: '10px', border: '1px solid #ddd'}}>
                    <p style={{fontSize: '12px', fontWeight: 'bold', marginBottom: '5px', color: '#666'}}>Debug: Tabby Response Data</p>
                    {Object.keys(debugData).length > 0 ? (
                      <>
                        <pre style={{fontSize: '11px', overflow: 'auto', maxHeight: '150px', background: '#fff', padding: '10px', borderRadius: '5px', border: '1px solid #eee'}}>
                          {JSON.stringify(debugData, null, 2)}
                        </pre>
                        <button 
                          onClick={() => {
                            navigator.clipboard.writeText(JSON.stringify(debugData, null, 2));
                            alert("Copied to clipboard!");
                          }}
                          style={{marginTop: '10px', fontSize: '12px', padding: '5px 10px', cursor: 'pointer'}}
                        >
                          Copy Response
                        </button>
                      </>
                    ) : (
                      <p style={{fontSize: '11px', color: '#999'}}>No query parameters found in the URL. If you just redirected from Tabby, please check the address bar for any info.</p>
                    )}
                  </div>
                )}

                <div style={{marginTop: '30px'}}>
                  <Link className="btn btn-primary btn-hover-dark" to="/" ref={homeLinkRef}>Go to Home</Link>
                </div>
                <div className="clr" />
              </div>
              <div className="clr" />
            </div>
          </div>
          <div className="clr" />
        </div>
      </section>
    </div>
  )
}


